// extracted by mini-css-extract-plugin
export default {"innerBox":"MarathonCreatedModal_innerBox__agwZR"};